// import hooks
import PhoneInput from "react-phone-input-2";
// import { useState } from "react";
import { useTranslation } from "react-i18next";

// import components

// import assets
import "react-phone-input-2/lib/style.css";

// import data
import ar from "react-phone-input-2/lang/ar.json";

const CustomPhoneInput = ({ phone, onHandleChange }) => {
    const [t, i18n] = useTranslation("global");
    const handleChange = (e) => {
        onHandleChange(e);
    };
    return (
        <div className="label-input-div custom-phone-input">
            <label className="custom-modal-label">
                {t("modals.signup.phone")}
            </label>
            <PhoneInput
                country={"sa"}
                value={phone}
                preferredCountries={["sa", "om", "qa", "ae", "kw"]}
                regions={["middle-east", "north-africa"]}
                localization={i18n.language == "ar" && ar}
                onChange={handleChange}
                excludeCountries={["il"]}
                enableAreaCodes={false}
            />
        </div>
    );
};

export default CustomPhoneInput;
